import DeployModal from './ContestModal.container'

export default DeployModal
